<template>
  <div>
    <van-row
      type="flex"
      justify="space-between"
      align="center"
      :class="[$style.bar, 'app-container ' + mode]"
      :style="{ 'background-color': background, 'z-index': zIndex }"
    >
      <van-col span="4">
        <slot name="left" v-if="showBack">
          <van-button
            v-if="forward"
            icon="arrow-left"
            type="default"
            :class="$style.back"
            :url="forward"
          />
          <van-button
            v-else
            icon="arrow-left"
            type="default"
            @click="goBack"
            :class="$style.back"
          />
        </slot>
      </van-col>
      <van-col span="16" :class="$style.title">{{ title }}</van-col>
      <van-col span="4">
        <van-button
          v-if="showMore"
          type="default"
          :class="[$style.menu, show ? 'active' : '']"
          @click="handlerShow"
        >
          <i />
          <i />
          <i />
        </van-button>
      </van-col>
    </van-row>

    <van-popup
      v-model="show"
      position="top"
      :overlay="false"
      :class="['app-container', $style.list]"
      @open="handlerOpen"
      @closed="handlerClosed"
    >
      <div
        @click="enterAccount"
        v-if="showProfile"
        :class="[$style.info, 'van-hairline--top']"
      >
        <van-icon name="user-circle-o" />
        {{ userInfo.login_code }}，您好
      </div>
      <ul>
        <li
          v-for="(item, key) in list"
          :key="key"
          :class="[
            item.hot && $style.hot,
            'van-hairline--top',
            key === list.length - 1 && 'van-hairline--bottom'
          ]"
        >
          <base-link
            :data="item"
            @handlerToken="handlerToken"
            @handlerShow="handlerShow"
          />
        </li>
      </ul>
    </van-popup>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import BaseLink from "@/components/BaseLink";
import tooken from "@/utils/tooken";
export default {
  name: "GlobalHeader",
  components: { BaseLink },
  props: {
    title: String,
    isFixed: Boolean,
    mode: { type: String, default: "light" },
    background: { type: String, default: "#48d5af" },
    showMore: {
      type: Boolean,
      default: true
    },
    showBack: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
      zIndex: "",
      cookieToken: tooken.getCookieToken()
    };
  },
  mounted() {
    //抓取浏览器现在的cookie中存储的token情况
    this.handlerToken();
  },
  computed: {
    ...mapGetters([
      "forward",
      "token",
      "userInfo",
      "businessLink",
      "vipLink",
      "hrLink",
      "headerShow",
      "aboutLink",
      "campusLink",
      "gameLink"
    ]),
    showProfile() {
      //路由不在个人中心页面，token存在，后台返回用户信息存在则显示
      let {
        meta: { parent },
        name
      } = this.$route;
      return (
        name !== "profile" &&
        parent !== "profile" &&
        Object.keys(this.userInfo).length > 0 &&
        this.token
      );
    },
    list() {
      // 极致产品
      let arr = [{ ...this.gameLink }],
        name = this.$route.name;
      // 极致VIP
      arr.push({ hot: true, ...this.vipLink });
      //显示客服中心
      if (name !== "gameHome" && this.$route.meta.parent !== "service") {
        arr.push({ ...this._anchor.gameHome });
      }
      // 关于我们
      arr.push({ ...this.aboutLink });

      // 商务合作
      arr.push({ ...this.businessLink });
      // 人才招聘
      arr.push({ ...this.hrLink });
      // 校园招聘
      arr.push({ ...this.campusLink });
      // 显示登录
      if (name !== "login" && !this.token) {
        arr.unshift(this._anchor.login);
      }
      // 显示首页
      if (name !== "index") {
        arr.unshift(this._anchor.index);
      }
      return arr;
    }
  },
  watch: {
    headerShow(val) {
      this.show = val;
    },
    cookieToken: {
      handler: function(val) {
        this.SetToken(val);
      }
    }
  },
  methods: {
    ...mapActions(["SetHeaderShow", "GetInfo", "SetToken", "SetLeave"]),
    /**
     * @description 判断浏览器缓存token是否存在
     */
    handlerToken() {
      this.SetToken(this.cookieToken);
      if (!this.token) return;
      this.GetInfo();
    },
    /**
     * @description 设置返回路径
     */
    setPath() {
      //父页面  个人中心与客服中心返回走向首页
      let subParentPath = ["profile", "gameHome"];

      let parentPath = this.$route.meta.back || this.$route.meta.parent;

      let path = "";
      if (parentPath && !subParentPath.includes(this.$route.name)) {
        path = `/${parentPath}`;
      } else {
        path = "/";
      }
      return path;
    },
    /**
     * @description 返回
     */
    goBack() {
      this.$router.replace({
        path: this.setPath()
      });
      if (!this.show) return;
      this.handlerShow();
    },
    /**
     * @description 进入账号中心
     */
    enterAccount() {
      this.$emit("handlerToken");
      this.$emit("handlerShow");
      this.SetLeave(true);
      this.$router.replace({
        path: this._anchor.profile.path
      });
    },
    /**
     * @description 控制头部菜单展开
     */
    handlerShow() {
      this.show = !this.show;
      this.SetHeaderShow(this.show);
    },
    /**
     * @description 头部层级变高
     */
    handlerOpen() {
      //实时获取浏览器里的token
      this.cookieToken = tooken.getCookieToken();
      this.zIndex = 9999;
    },
    /**
     * @description 头部层级变低
     */
    handlerClosed() {
      //实时获取浏览器里的token
      this.cookieToken = tooken.getCookieToken();
      this.zIndex = 999;
    }
  }
};
</script>

<style module lang="less">
.bar {
  z-index: 999;
  position: fixed;
  left: 0;
  right: 0;
  height: @global-header-height;

  > div:last-child {
    text-align: right;
  }

  :global {
    .van-button {
      height: @global-header-height;
      padding: 0 0.3rem;
      border: 0;
      border-radius: 0;
      background-color: transparent;
      line-height: inherit;
    }
  }

  &:global(.light) {
    color: @global-header-light-color;
  }

  &:global(.dark) {
    color: @global-header-dark-color;
  }
}

.title {
  font-size: 0.3rem;
  text-align: center;
}

// 返回
.back {
  &:global(.van-button) {
    display: inline-flex;
    align-items: center;
    color: inherit;
  }

  :global {
    .van-button__icon {
      font-size: 0.38rem;
    }
  }
}

// 菜单
.menu {
  :global {
    .van-button__text {
      .size(
        @global-header-menu-button-width,
        @global-header-menu-button-height
      );
      display: inline-block;
      position: relative;

      i {
        .size(@global-header-menu-button-width * 0.75, @global-header-menu-bar);
        position: absolute;
        right: 0;
        transition: all 0.3s;

        :global(.light) & {
          background-color: @global-header-light-color;
        }

        :global(.dark) & {
          background-color: @global-header-dark-color;
        }

        &:first-child {
          top: 0;
        }

        &:nth-child(2) {
          top: @global-header-menu-bar-center;
          width: @global-header-menu-button-width;
        }

        &:last-child {
          bottom: 0;
        }
      }
    }
  }

  // 激活菜单
  &:global(.active) {
    i {
      &:first-child,
      &:last-child {
        width: @global-header-menu-button-width;
      }

      &:first-child {
        top: @global-header-menu-bar-center;
        transform: rotate(-45deg);
      }

      &:last-child {
        bottom: @global-header-menu-bar-center;
        transform: rotate(45deg);
      }

      &:nth-child(2) {
        opacity: 0;
      }
    }
  }
}

// 菜单列表
.list {
  right: 0;
  height: 100%;
  padding-top: @global-header-height + 0.01;
  box-sizing: border-box;

  ul {
    z-index: 1;
    position: relative;
  }

  li {
    :global {
      .van-button {
        .size(100%, auto);
        padding: 1.5em 0;
        border: 0;
        background-color: transparent;
        font-size: 0.28rem;
        line-height: inherit;
      }
    }
  }
}

.hot {
  position: relative;
  &::before {
    .size(0.89rem, 0.52rem);
    content: "";
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
    background: url("./images/tag-hot.png") no-repeat;
    background-size: 100% 100%;
    pointer-events: none;
  }
}

.info {
  padding: 1.5em 0;
  font-size: 0.28rem;
  text-align: center;

  :global {
    .van-icon {
      margin-right: 0.4em;
      font-size: 0.48rem;
      color: #ff8830;
      vertical-align: middle;
    }
  }
}
</style>
